// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";
const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: icon("customer"),
  lock: icon("settings"),
  staff: icon("staff"),
  menuItem: icon('menu'),
  catalog: icon("ic_ecommerce"),
  analytics: icon("report"),
  accounting: icon("report"),
  businessPartner: icon("customer"),
  venue: icon("ic_booking"),
  warehouse: icon("ic_ecommerce"),
  subscription: icon("ic_invoice"),
  dashboard: icon("dashboard"),
  promotion: icon("ic_label"),
};

const navConfig = [
  // GENERAL
  {
    subheader: "Welcome Back!",
    items: [
      {
        title: "dashboard",
        path: PATH_DASHBOARD.general.app,
        pathList: [PATH_DASHBOARD.general.app],
        icon: ICONS.dashboard,
      },
      // STAFF
      {
        title: "staff",
        path: PATH_DASHBOARD.user.account,
        pathList: [
          PATH_DASHBOARD.user.account,
          PATH_DASHBOARD.user.new,
          PATH_DASHBOARD.user.list,
          PATH_DASHBOARD.user.profile,
          PATH_DASHBOARD.desigination.new,
          PATH_DASHBOARD.user.edit,
          PATH_DASHBOARD.user.replicate,
        ],
        icon: ICONS.staff,
      },

      // MENU
      {
        title: "menu",
        path: PATH_DASHBOARD.menu.display,
        pathList: [
          PATH_DASHBOARD.menu.display,
          // PATH_DASHBOARD.ingredient.new,
          // PATH_DASHBOARD.ingredient.edit,
          PATH_DASHBOARD.category.new,
          PATH_DASHBOARD.category.edit,
          PATH_DASHBOARD.category.replicate,
          PATH_DASHBOARD.item.new,
          PATH_DASHBOARD.item.edit,
          PATH_DASHBOARD.item.replicate,
          // PATH_DASHBOARD.choice.new,
          // PATH_DASHBOARD.choice.edit,
          // PATH_DASHBOARD.choice.replicate,
          // PATH_DASHBOARD.recipe.new,
          // PATH_DASHBOARD.recipe.edit,
          // PATH_DASHBOARD.recipe.replicate,
        ],
        icon: ICONS.menuItem,
      },

      // CATALOG
      {
        title: "catalog",
        path: PATH_DASHBOARD.catalog.categories.list,
        pathList: [
          PATH_DASHBOARD.catalog.categories.list,
          PATH_DASHBOARD.catalog.categories.new,
          PATH_DASHBOARD.catalog.categories.edit,
          PATH_DASHBOARD.catalog.products.list,
          PATH_DASHBOARD.catalog.products.new,
          PATH_DASHBOARD.catalog.products.edit,
          PATH_DASHBOARD.catalog.choiceGroups.list,
          PATH_DASHBOARD.catalog.choiceGroups.new,
          PATH_DASHBOARD.catalog.choiceGroups.edit,
          PATH_DASHBOARD.catalog.boms.list,
          PATH_DASHBOARD.catalog.boms.new,
          PATH_DASHBOARD.catalog.boms.edit,
        ],
        icon: ICONS.catalog,
        children: [
          {
            title: "categories",
            path: PATH_DASHBOARD.catalog.categories.list,
            pathList: [
              PATH_DASHBOARD.catalog.categories.list,
              PATH_DASHBOARD.catalog.categories.new,
              PATH_DASHBOARD.catalog.categories.edit,
            ],
          },
          {
            title: "products",
            path: PATH_DASHBOARD.catalog.products.list,
            pathList: [
              PATH_DASHBOARD.catalog.products.list,
              PATH_DASHBOARD.catalog.products.new,
              PATH_DASHBOARD.catalog.products.edit,
            ],
          },
          {
            title: "choice groups",
            path: PATH_DASHBOARD.catalog.choiceGroups.list,
            pathList: [
              PATH_DASHBOARD.catalog.choiceGroups.list,
              PATH_DASHBOARD.catalog.choiceGroups.new,
              PATH_DASHBOARD.catalog.choiceGroups.edit,
            ],
          },
          {
            title: "BOM",
            path: PATH_DASHBOARD.catalog.boms.list,
            pathList: [
              PATH_DASHBOARD.catalog.boms.list,
              PATH_DASHBOARD.catalog.boms.new,
              PATH_DASHBOARD.catalog.boms.edit,
            ],
          },
        ],
      },

      // REPORTS
      {
        title: "report",
        path: PATH_DASHBOARD.general.report,
        pathList: [PATH_DASHBOARD.general.report],
        icon: ICONS.analytics,
      },
      {
        title: "accounting",
        path: PATH_DASHBOARD.accounting.root,
        pathList: [
          PATH_DASHBOARD.accounting.root,
          PATH_DASHBOARD.accounting.new,
          PATH_DASHBOARD.accounting.edit,
          PATH_DASHBOARD.accounting.journals,
          PATH_DASHBOARD.accounting.journalNew,
          PATH_DASHBOARD.accounting.journalEdit,
          PATH_DASHBOARD.accounting.journalDetail,
          PATH_DASHBOARD.accounting.settings,
        ],
        icon: ICONS.accounting,
        children: [
          {
            title: "accounts",
            path: PATH_DASHBOARD.accounting.root,
            pathList: [
              PATH_DASHBOARD.accounting.root,
              PATH_DASHBOARD.accounting.new,
              PATH_DASHBOARD.accounting.edit,
            ],
          },
          {
            title: "journals",
            path: PATH_DASHBOARD.accounting.journals,
            pathList: [
              PATH_DASHBOARD.accounting.journals,
              PATH_DASHBOARD.accounting.journalNew,
              PATH_DASHBOARD.accounting.journalEdit,
              PATH_DASHBOARD.accounting.journalDetail,
            ],
          },
          {
            title: "settings",
            path: PATH_DASHBOARD.accounting.settings,
            pathList: [PATH_DASHBOARD.accounting.settings],
          },
        ],
      },

      {
        title: "business partner",
        path: PATH_DASHBOARD.businessPartner.root,
        pathList: [
          PATH_DASHBOARD.businessPartner.root,
          PATH_DASHBOARD.businessPartner.vendorList,
          PATH_DASHBOARD.businessPartner.vendorNew,
          PATH_DASHBOARD.businessPartner.vendorEdit,
          PATH_DASHBOARD.businessPartner.vendorDetail,
          PATH_DASHBOARD.businessPartner.customerList,
          PATH_DASHBOARD.businessPartner.customerNew,
          PATH_DASHBOARD.businessPartner.customerEdit,
          PATH_DASHBOARD.businessPartner.customerDetail,
        ],
        icon: ICONS.businessPartner,
        children: [
          {
            title: "vendor partners",
            path: PATH_DASHBOARD.businessPartner.vendorList,
            pathList: [
              PATH_DASHBOARD.businessPartner.vendorList,
              PATH_DASHBOARD.businessPartner.vendorNew,
              PATH_DASHBOARD.businessPartner.vendorEdit,
              PATH_DASHBOARD.businessPartner.vendorDetail,
            ],
          },
          {
            title: "customer partners",
            path: PATH_DASHBOARD.businessPartner.customerList,
            pathList: [
              PATH_DASHBOARD.businessPartner.customerList,
              PATH_DASHBOARD.businessPartner.customerNew,
              PATH_DASHBOARD.businessPartner.customerEdit,
              PATH_DASHBOARD.businessPartner.customerDetail,
            ],
          },
        ],
      },

      {
        title: "branches",
        path: PATH_DASHBOARD.venues.list,
        pathList: [
          PATH_DASHBOARD.venues.list,
          PATH_DASHBOARD.venues.new,
          PATH_DASHBOARD.venues.detail,
          PATH_DASHBOARD.venues.edit,
        ],
        icon: ICONS.venue,
      },
      {
        title: "warehouses",
        path: PATH_DASHBOARD.warehouses.list,
        pathList: [
          PATH_DASHBOARD.warehouses.list,
          PATH_DASHBOARD.warehouses.new,
          PATH_DASHBOARD.warehouses.detail,
          PATH_DASHBOARD.warehouses.edit,
        ],
        icon: ICONS.warehouse,
      },
      {
        title: "customers",
        path: PATH_DASHBOARD.customer.list,
        pathList: [
          PATH_DASHBOARD.customer.list,
          PATH_DASHBOARD.customer.edit,
          PATH_DASHBOARD.customer.account,
          PATH_DASHBOARD.customer.profile,
          PATH_DASHBOARD.customer.new,
        ],
        icon: ICONS.user,
      },
      {
        title: "store",
        path: PATH_DASHBOARD.store.themeList,
        pathList: [
          PATH_DASHBOARD.store.themeList,
          PATH_DASHBOARD.store.themePreview(":themeName"),
          PATH_DASHBOARD.store.elementditTheme(":themeName"),
          PATH_DASHBOARD.page.list,
          PATH_DASHBOARD.page.new,
          PATH_DASHBOARD.page.edit,
          PATH_DASHBOARD.page.account,
          PATH_DASHBOARD.page.profile,
        ],
        icon: ICONS.lock,
      },
      {
        title: "promotions",
        path: PATH_DASHBOARD.promotion.list,
        pathList: [
          PATH_DASHBOARD.promotion.list,
          PATH_DASHBOARD.promotion.new,
          PATH_DASHBOARD.promotion.edit,
        ],

        icon: ICONS.promotion,
      },
      {
        title: "settings",
        path: PATH_DASHBOARD.settings.new,
        pathList: [
          PATH_DASHBOARD.settings.new,
          PATH_DASHBOARD.settings.kds,
          PATH_DASHBOARD.settings.edit,
        ],
        icon: ICONS.lock,
      },
    ],
  },
];

const disableItem = (item) => ({
  ...item,
  disabled: true,
  children: item.children?.map(disableItem),
});

export const getDashboardNavConfig = (user) => {
  const isOverdue = user?.isOverdue === true || user?.franchiseId?.isOverdue === true;

  return navConfig.map((group) => {
    let items = group.items;

    if (!user?.permissions?.canViewDashboard) {
      items = items.filter((item) => item.title !== "dashboard");
    }
    if (!user?.permissions?.canViewStaff) {
      items = items.filter((item) => item.title !== "staff");
    }
    if (!user?.permissions?.canAccessReports) {
      items = items.filter((item) => item.title !== "report");
    }
    if (!user?.permissions?.canViewVenueCustomers) {
      items = items.filter((item) => item.title !== "customers");
    }
    if (!user?.franchiseId?.configurations?.isStoreAvailable && !user?.franchiseId?.configurations?.isStoreAvailableOnApp) {
      items = items.filter((item) => item.title !== "store");
    }

    return {
      ...group,
      items: isOverdue ? items.map(disableItem) : items,
    };
  });
};

export default navConfig;
